import { RingLoader } from "react-spinners";
import styled from "styled-components";

const LoadContainer = styled.div`
  width: 100%;
  max-width: 45rem;
  height: 100vh;
  position: fixed;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
  display: flex;
  z-index: 9999;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: rgba(0, 0, 0, 0.5);
`;

const LoadingTxt = styled.span`
  color: #fac780;
  font-size: 1.4rem;
  font-weight: 600;
  opacity: 0.7;
  margin-top: 10px;
`;

export const FadeLoading = () => {
  return (
    <LoadContainer>
      <RingLoader size={70} color="#FAC780" />
      <LoadingTxt>분석중...</LoadingTxt>
    </LoadContainer>
  );
};
